// import { getAccessTokenSilently as getToken } from '@auth0/auth0-spa-js';

let getAccessTokenSilently;
let getIdTokenClaims;
let auth0Client;

export const sec = {
  getAccessTokenSilently: function() {
    return getAccessTokenSilently;
  },
  getIdTokenClaims: function() {
    return getIdTokenClaims;
  },
  getAuth0Client: function() {
    return auth0Client;
  },
  setAccessTokenSilently: function(func) {
    getAccessTokenSilently = func;
  },
  setIdTokenClaims: function(func) {
    getIdTokenClaims = func;
  },
  setAuth0Client: function(client) {
    auth0Client = client;
  },
};
